import { createContext } from 'react';

import { DataProviderQueryStatus } from '../../next/CustomDash/components/DataProvider/types';
import { PreferenceScope, type UserPreferences } from './types';
import { getDefaultPreferences } from './utils/preference-defaults';

interface UserPreferencesContextValue {
  preferences: UserPreferences;
  status: DataProviderQueryStatus;
  /**
   * The page scope the merged `preferences` view was resolved for. Consumers
   * that turn a stored preference into filter state (e.g. taxonomy hooks)
   * need this to derive scope-correct values — see
   * `deriveEffectiveTaxonomiesForScope`.
   */
  scope: PreferenceScope;
}

/**
 * Pass through context for when using <UserPreferenceDataProvider /> doesn't make sense. For example, use in multiple hooks.
 * */
export const UserPreferencesContext =
  createContext<UserPreferencesContextValue>({
    preferences: getDefaultPreferences(PreferenceScope.GLOBAL),
    status: DataProviderQueryStatus.Idle,
    scope: PreferenceScope.GLOBAL,
  });
